import { accountStore } from '../lib/studyStorage';

export interface SavedStudySession {
  id: string;
  title: string;
  subject: string;
  topicName?: string;
  type: 'text' | 'video';
  uploadType: 'PDF' | 'Image' | 'File';
  createdAt: string;
  lastOpenedAt?: string;
}

const store = accountStore<SavedStudySession[]>('study_sessions', () => []);

function loadSessions(): SavedStudySession[] {
  return store.read();
}

function saveSessions(items: SavedStudySession[]) {
  store.write(items);
}


export function createStudySession(
  data: Omit<SavedStudySession, 'id' | 'createdAt'>
): SavedStudySession {
  const sessions = loadSessions();
  const now = new Date().toISOString();
  const id = `session-${now}-${Math.random().toString(36).slice(2, 8)}`;
  const session: SavedStudySession = { ...data, id, createdAt: now };
  sessions.unshift(session);
  if (sessions.length > 200) sessions.pop();
  saveSessions(sessions);
  return session;
}

export function renameStudySession(id: string, newTitle: string): boolean {
  const sessions = loadSessions();
  const idx = sessions.findIndex((s) => s.id === id);
  if (idx < 0) return false;
  sessions[idx] = { ...sessions[idx], title: newTitle };
  saveSessions(sessions);
  return true;
}

export function deleteStudySession(id: string): boolean {
  let sessions = loadSessions();
  const before = sessions.length;
  sessions = sessions.filter((s) => s.id !== id);
  if (sessions.length === before) return false;
  saveSessions(sessions);
  return true;
}

export function getStudySessions(): SavedStudySession[] {
  return loadSessions();
}

export function getRecentSessions(limit = 10): SavedStudySession[] {
  return loadSessions().slice(0, limit);
}

export function markSessionOpened(id: string) {
  const sessions = loadSessions();
  const idx = sessions.findIndex((s) => s.id === id);
  if (idx >= 0) {
    sessions[idx] = { ...sessions[idx], lastOpenedAt: new Date().toISOString() };
    saveSessions(sessions);
  }
}

export function clearStudySessions() {
  saveSessions([]);
}

export function hasAnySessions(): boolean {
  return loadSessions().length > 0;
}